/* eslint-disable no-nested-ternary */
import { Invoice } from '../../../providers/api/dtos';
import { InvoiceFormModel } from '../../components/invoice-form/InvoiceForm';

export const toInvoiceFormModel = (invoice: Invoice): Partial<InvoiceFormModel> => ({
  type: invoice.type,
  value: invoice.value?.toString(),
  paidValue: invoice.paidValue?.toString(),
  paymentDate: invoice.paymentDate,
  invoiceId: invoice.invoiceId,
  proformaInvoiceId: invoice.proformaInvoiceId,
  notes: invoice.notes.length > 0 ? invoice.notes[0].text : undefined,
  paymentMethod: invoice.paymentMethod,
  vat: invoice.vat?.toString(),
});
